import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router'

export const useRouteChangeConfirm = (when, onBlock = () => {}) => {
  const history = useHistory()
  const unblock = useRef(null)

  useEffect(() => {
    if (when) {
      /*
       * Block navigation and register a callback that
       * fires when a navigation attempt is blocked.
       */
      unblock.current = history.block((tx) => {
        const next = () => {
          // Unblock
          unblock.current && unblock.current()

          // Next page
          history.push({
            pathname: tx.pathname,
            search: tx.search,
          })
        }

        onBlock({ next, path: tx.pathname })
        return false
      })
    } else {
      unblock.current = null
    }

    return () => {
      if (unblock.current) {
        unblock.current()
      }
    }
  }, [when, history, onBlock])

  return { unblock }
}

export default useRouteChangeConfirm
